import './en.darwin'; // 15%
import './zh-hans.darwin';
import './en-uk.darwin';
import './es.darwin';
import './jp-roman.darwin';
import './de.darwin';
import './en-intl.darwin';
import './en-ext.darwin';
import './fr.darwin';
import './jp.darwin';
import './pl.darwin';
import './it.darwin';
import './ru.darwin';
import './pt.darwin';
import './ko.darwin';
import './dvorak.darwin';

export { KeyboardLayoutContribution } from './_.contribution';
